const asRecord = (value) => value && typeof value === "object" ? value : {};
const unwrap = (value) => {
  const record = asRecord(value);
  const inner = record.data ?? record.result;
  return inner && typeof inner === "object" ? inner : record;
};
const planUrlOf = (raw) => raw.imageUrl ?? raw.backgroundImageUrl ?? raw.planImageUrl ?? void 0;
const toSeatFloorPin = (raw, index) => ({
  pinId: String(raw.pinId ?? raw.id ?? index),
  memberGuid: raw.memberGuid ?? raw.memberGUID ?? void 0,
  fullName: raw.fullName ?? raw.memberName ?? "",
  x: Number(raw.x ?? 0),
  y: Number(raw.y ?? 0),
  departmentPath: raw.departmentPath ?? void 0,
  positionName: raw.positionName ?? void 0,
  titleName: raw.titleName ?? void 0,
  profileImageUrl: raw.profileImageUrl ?? void 0,
  companyEmail: raw.companyEmail ?? void 0,
  extensionNo: raw.extensionNo ?? void 0
});
const parseMemberSeatLocation = (value) => {
  const raw = unwrap(value);
  if (raw.floorId == null) return null;
  return {
    memberGuid: raw.memberGuid ?? raw.memberGUID ?? void 0,
    floorId: String(raw.floorId),
    floorName: raw.floorName ?? "",
    workPlaceName: raw.workPlaceName || void 0,
    planUrl: planUrlOf(raw),
    x: Number(raw.x ?? 0),
    y: Number(raw.y ?? 0)
  };
};
const parseSeatFloorPlan = (value) => {
  const raw = unwrap(value);
  const rawPins = raw.pins ?? raw.seatPins ?? raw.items;
  return {
    floorId: raw.floorId == null ? "" : String(raw.floorId),
    floorName: raw.floorName ?? "",
    workPlaceId: raw.workPlaceId == null ? void 0 : Number(raw.workPlaceId),
    workPlaceName: raw.workPlaceName || void 0,
    totalSeatCount: raw.totalSeatCount ?? void 0,
    sortOrder: raw.sortOrder ?? void 0,
    planUrl: planUrlOf(raw),
    pins: Array.isArray(rawPins) ? rawPins.map(
      (pin, index) => toSeatFloorPin(pin, index)
    ) : []
  };
};
const formatSeatFloorLabel = (floorName, workPlaceName) => [workPlaceName, floorName].filter(Boolean).join(" ");
const formatDepartmentPath = (departmentPath) => (departmentPath ?? "").split("/").map((unit) => unit.trim()).filter(Boolean).join(" · ");
const formatPinCaption = (pin) => [
  [pin.titleName, pin.positionName].filter(Boolean).join(" · "),
  formatDepartmentPath(pin.departmentPath)
].filter(Boolean).join(" | ");
export {
  formatDepartmentPath,
  formatPinCaption,
  formatSeatFloorLabel,
  parseMemberSeatLocation,
  parseSeatFloorPlan
};
